import type { FileData } from 'src/data-capture/hooks/file-uploads/types';

export enum TranscriptionStatus {
  READY = 'READY',
  PROCESSING = 'PROCESSING',
  FAILED = 'FAILED',
  EMPTY = 'EMPTY',
}

export type TranscriptSegment = {
  speaker: string;
  // Stable diarisation label the backend keys speaker corrections on, e.g.
  // "SPEAKER_0". Null on transcripts that predate diarisation capture, where the
  // display `speaker` is itself the label to correct against.
  diarisationLabel?: string | null;
  content: string;
  startTime: string;
  endTime: string;
};

export type Transcript = {
  status: TranscriptionStatus;
  id?: string;
  eventId?: string;
  file?: FileData;
  segments?: TranscriptSegment[];
  summary?: string;
  summaryStatus: 'NOT_STARTED' | 'IN_PROGRESS' | 'ERROR' | 'COMPLETED';
  dataUploadFileId?: string;
};
